
export default {
  "m":{
    "sms_login":"단문 메시지 로그인",
    "get_vercode":"발송",
    "change_mobile":"전화번호 변경",
    "log_reg_agree":"로그인/등록은 {msg_ss}에 동의한다는 의미입니다",
    "old_mobile":"원래 전화번호",
    "new_mobile":"새 전화번호",
    "agency_reginfo_fill":"길드 등록 정보 입력",
    "audit_res":"감사 결과",
    "agency_name":"길드명",
    "agency_name_input":"길드명을 입력해주세요",
    "agency_name_input_note":"참고: 길드 이름은 30단어 이내로 짧고 기억하기 쉬운 것을 권장합니다",
    "agency_logo":"길드 로고",
    "agency_logo_unpload_note":"PNG/JPG/JPEG 형식의 명확한 길드 로고를 업로드하세요",
    "agency_contact_name":"길드연락처",
    "user_contact_name":"사용자 플랫폼과 매일 연락하는 사람의 이름을 입력하십시오",
    "agency_contact_phone":"길드연락처 전화번호",
    "agency_whatsapp":"길드장 WhatsApp",
    "agency_whatsapp_contact":"길드장 WhatsApp 연락처를 입력해주세요.",
    "agency_use_lang":"길드장이 사용하는 언어",
    "agency_head_ID":"길드장 아이디",
    "agency_ID_input":"추후 자금 분배를 위해 길드장 BuzzCast APP의 사용자 ID를 입력하십시오",
    "reg_country":"등록 국가",
    "inhand_ID_photo":"사진이 부착된 신분증",
    "upload_note_t":"업로드 고려 사항",
    "agency_self_inhand_ID":"대리인이 여권 서류와 함께 직접 휴대해야 합니다",
    "photo_must_clearly":"사진을 촬영하여 앞면에 본인과 실제 여권 정보가 명확하게 표시되어야 합니다",
    "mian_form_country":"호스트의 주요 소스 국가",
    "invite_code":"초대 코드",
    "your_profile_submit_success":"문서가 성공적으로 제출되었습니다! 우리는 가능한 한 빨리 그것을 처리할 것입니다.<br>감사 결과는 길드장의 BuzzCast APP 알림으로 전송될 예정이니 많은 관심 부탁드립니다!",
    "your_profile_approved":"제출하신 서류는 심사를 통과하지 못했습니다! 거절사유는 소지하고 있는 여권 사진이 불명확합니다.\"<br>다시 작성하시거나 BuzzCastAPP 공식 어시스턴트에게 문의해 주세요.",
    "return_refill":"돌아가서 채우세요",
    "success_agency":"플랫폼을 성공적으로 설치한 것을 축하합니다. [클릭 해주세요] 작업을 시작하십시오!",
    "personal_account":"개인 계정",
    "my_agency":"내 길드",
    "your_agency_been_forcibly":"귀하의 길드는 플랫폼에 의해 강제 종료되었으며 더 이상 시스템에 로그인할 수 없습니다. 궁금한 사항이 있으시면 BuzzCastAPP의 공식 어시스턴트 또는 독점 운영에 문의하십시오.",
    "invite_live_join":"길드 링크에 호스트 초대",
    "base_info":"기본 정보",
    "apply_time":"지원 날짜",
    "join_time":"참여 시간",
    "cooper_status":"협력 현황",
    "streamer_manage":"호스트 관리",
    "sereamer_apply":"호스트 승인",
    "sereamer_nickname":"호스트 닉네임",
    "remark":"주목",
    "no_remark":"비고 없음",
    "add_remark":"비고 추가",
    "birth":"생일",
    "user_status":"사용자 상태",
    "temporarily_frozen":"일시적 동결",
    "permanently_frozen":"영원히 동결",
    "fans_num":"팔로워 수",
    "sign_status":"계약 상태",
    "sign_ing":"계약중",
    "sign_time":"계약일",
    "release_time":"취소 날짜",
    "live_viola_record":"생방송 위반 기록",
    "sign_record":"계약 기록",
    "current_contract_status":"현재 계약 상태",
    "termination_reason":"해지 사유",
    "violation_reason":"위반 사유",
    "violation_time":"위반 날짜",
    "processing_result":"처리 결과",
    "exported_data":"데이터 내보내기",
    "join_agency_apply":"길드 가입 승인",
    "audit_status":"승인 상태",
    "pending_review":"검토를 보류하다",
    "pending_HQ_review":"본사 검토를 기다리는 중",
    "not_approved_HQ":"본사 검토 실패",
    "withdrawn":"취소됨",
    "audit_trail":"기록 검토",
    "oper":"운영",
    "other_video_materials":"기타 비디오 문서",
    "pass":"통과하다",
    "pass_streamer_join_agency_apply":"호스트 길드 가입 신청서 통과",
    "reject_streamer_join_agency_apply":"호스트의 길드 가입 신청 거부",
    "agree_streamer_join_agency":"{msg_ss2} 이하의 발신자가 되려면 앵커 {msg_ss1}에 동의하세요~",
    "reject_streamer_join_agency":"회원 {msg_ss1}의 {msg_ss2} 회원 신청이 거부되었습니다!",
    "img_material":"그림 문서",
    "approver":"승인자",
    'user_enter_bind_phone':'핸드폰 번호를 입력해 주세요',
    'vericode':'확인 코드',
    'input_vericode':'인증 코드를 입력하십시오',
    'login':'로그인',
    'reg':'등기',
    'logout':'로그아웃',
    'search_for':'검색',
    'subscription_closed':'취소된 계약',
    'agency_ID':'길드 코드: {msg_ss}',
    'reset':'재설정',
    'live_ID':'앵커아이디',
    'live_record':'라이브 방송 화면 녹화',
    'email':'메일',
    'phone':'휴대폰번호',
    'mastery_lang':'사용 언어',
    'to':'까지',
    'cancel':'취소',
    'Confirm':'OK',
    'preview':'미리보기',
    'rejected':'거부 됨',
    'tip':'프롬프트',
    'i_got_it':'알았다',
    'cancelled':'취소 된',
    'refused':'거부',
    'agency_agree':'길드가 동의했습니다',
    'platform_agree':'플랫폼이 동의했습니다',
    'user_not_exist':'이 사용자는 존재하지 않습니다',
    'user_frozen':'이 사용자는 금지되었습니다.',
    'reviewing':'검토 중',
    'review_pass':'검토 통과',
    'review_failed':'감사 실패',
    'xx_hours':'{msg_ss} 시간',
    'xx_days':'{msg_ss} 일',
    'xx_hour': '{msg_ss} 시간',
    'xx_day': '{msg_ss} 일',
    'xx_year': '{msg_ss} 년',
    'xx_years': '{msg_ss} 년',
    'check_phone_istrue':'전화 번호가 정확히 입력되었는지 확인하세요',
    'male':'남자',
    'female':'여자',
    'avatar':'프로필사진',
    'normal':'일반',
    'live_room':'라이브 룸',
    'view':'보기',
    'oper_success':'성공적인 작업',
    'copy_success':'성공적인 사본',
    'new_mobile_already_reg':'새로운 휴대폰 번호가 등록되었습니다',
    'general_user':'일반 사용자',

    'copy':'복사',
    'gender':'성별',
    'submit':'제출',
    'permanent':'영구',
    'agree_agreement':'계약에 동의하고 준수합니다',
    'vericode_error':'확인 코드가 잘못되었습니다.',
    'resend':'좋아요취소',
    'approved':'통과',
    'not_approved':'통과하지 못했습니다',
    'agency_rejected':'플랫폼 거부됨',
    'select':'선택',
    'search':'검색',
    'rejection_reason':'거부 사유',
    'no_data':'데이터 없음',
    'oper_failed':'작업 실패',
    'leave_agency_apply':'길드 탈퇴 승인',
    'over_word_limit':'입력한도를 넘었습니다.',
    'delete':'삭제',
    'nickname':'별명',
    'file_is_too_large':'너무 큰 파일',

    'community_convention':'버즈캐스트 커뮤니티 컨벤션',
    'approval_time':'결재시간',
    'guild_system_title':'버즈캐스트 소셜 플랫폼 길드 시스템입니다.',
    'return':'되돌아가다.',
    'img_upload_fail':'그림 업로드에 실패했습니다.',
    'cooper_ing':'협력 중입니다.',
    'upload_file_format_incorrect':'업로드된 파일의 형식이 올바르지 않습니다.',
    'token_invalid':'토큰이 잘못되었습니다. 다시 로그인하십시오!',
    'network_busy':'네트워크가 바쁩니다. 다시 시도하십시오',
    'minute':'{msg_ss}분',

    'live_room_ID':'생방송실ID',
    'scan_code':'BuzzCast 앱에 스캔 로그인합니다',
    'open_code':'BuzzCast 앱을 열고 내 QR코드를 클릭하여 스캔합니다.',
    'refresh':'갱신하다',
    'login_confirm':'로그인 확인입니다',
    'account':'계정 정보',
    'user_name':'아이디',
    'edit':'개정하다',
    'changing':'바인딩을 바꿉니다',
    'mobile_number':'핸드폰 아이디',
    'mobile_login':'핸드폰 번호 {msg_ss}로 로그인 할 수 있습니다',
    'appId_login':'AppID가 [{msg_ss}]인 계정으로 로그인을 스캔할 수 있습니다.',
    'code_login':'BuzzCastAppID가 연동되지 않아 연동 후 QR코드 스캔으로 로그인 가능합니다.',
    'verification_log':'휴대폰번호가 연동되어 있지 않으며, 연동 후 휴대폰번호와 인증번호로 로그인 할 수 있습니다.',
    'binding_success':'바인딩이 성공했습니다.',
    'binding_mobile':'휴대폰 번호를 연동합니다.',
    'edit_name':'사용자 이름을 수정합니다.',
    'binding_alert':'바인딩 힌트를 바꿉니다.',
    'new_appId':'새로운 APPID를 직접 스캔하여 바인딩하면 기존 APPID가 바로 교체됩니다.',
    'binding_account':'BuzzCast 앱의 계정을 연동합니다.',
    'anchor_earings':'아나운서의 수익',
    'signing_date':'계약날짜',
    'statistical_date':'통계 일짜',
    'valid_min':'총 유효 시간(분)입니다.',
    'valid_day':'유효일수( 일수)',
    'total_revenue':'총수익',

    'bind':'바인딩',
    'please_agree_agree':'계약에 동의해주세요',
    'note':'참고: 이 시스템에 표시되는 시간은 뉴욕 시간(EST)입니다.',
    'app_phone':'APP의 휴대폰 번호 등록',
    'host_num':'호스트 수',
    'enter_host_num':'모든 호스트의 번호를 입력하십시오',
    'platform':'협력 플랫폼',
    'statement':'월간 은행 명세서',
    'enter_income':'월 평균 소득을 입력하세요',
    'check_commas':'잘못된 형식입니다. 여러 플랫폼이 쉼표로 구분되어 있는지 확인하세요',
    'submit_success':'문서가 성공적으로 제출되었습니다! 우리는 가능한 한 빨리 그것을 처리할 것입니다',
    'usd':'USD',
    'many_platforms':'이전에 협력했던 생방송 플랫폼을 최대 20개까지 입력하세요',
    'limit_platform': '최대 20개 플랫폼',
    'user_has_delete':'사용자가 취소되었습니다',
    'cant_commit':'이미 계약된 호스트이며,에이전시 동시 입점 신청을 할수없습니다',
    'cant_commit_1':'호스트 계약 신청 중이며, 에이전시 동시 입점 신청을 할수없습니다',
    'passwd': '비밀번호',
    'passwd_placeholder': '비밀번호은 6에서 20까지 가능하다. ',
    'live_rights': '시간이 없는 평가',
    'edit_log': '레코드 변경',
    'edit_time': '시간수정',
    'edit_pwd': '비밀번호 변경',
    'old_pwd': '기존 비밀번호',
    'new_pwd': '새 비밀번호',
    'confirm_pwd': '비밀번호 확인',
    'forget_pwd': '비밀번호를 잃기',
    'email_check': '전자 메일 형식이 잘못되었습니다',
    'phone_pwd_error': '번호가 틀린 ',
    'ten_min_error': '10분 후에 다시 시도하십시오.',
    'phone_bind_error': '휴대폰 번호가 다른 계정에 바인딩되어 있습니다. 바인딩 할 새 휴대폰 번호를 교체하십시오.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': '길드장 ID 이미 입력되어 있습니다. 다시 입력해주세요',
    'pwd_error': '잘못된 비밀번호',
    'phone_not_reg_error': '계정이 등록되지 않았습니다',
    'pwd_nq': '입력 한 새 비밀번호가 일치하지 않습니다',
    'sign_anchor_error': '이미 계약된 방송인이며, 동시에 정착할 길드를 신청할 수 없습니다',
    'apply_anchor_error': '이미 계약된 방송사를 신청하셨고, 동시에 정착할 길드 신청은 불가합니다',
    'have-expired':'만료됨',
    'approval-time':'승인 시간',
    'reasons-for-refusal':'거부 사유를 입력하십시오',
    'Transfer-grounds':'이적 이유:',
    'code_expire': '확인 코드가 만료되었습니다. 새로 고치려면 확인 코드를 클릭하십시오',
    'transfer-approval':'이적 승인',
    'live_state_placeholder': '시작 상태',
    'live_state_open': '정상',
    'live_state_temporary_banned': '방송 금지',
    'live_state_forever_banned': '영구히 방송을 금지',
    'live_allowed_time': '방송 허락 시간',
    'live_banned_time': '방송 금지 주기',
    'deduct_money': 'B 코인의 금액을 공제합니다.',
    'final_income': '실질 소득',
    'select_start_dt': '시작 시간을 선택하십시오',
    'select_end_dt': '종료 시간을 선택하십시오.',
    'less_then_end_dt': '시작 시간은 종료 시간보다 작거나 같아야 합니다.',
    'System_automatically_through':'시스템이 자동으로 통과합니다.',
    'btrade_err': '대리점 ID를 사용할 수 없습니다.',

    'mouth_anchor': '월급 비제이',
    'day_anchor': '일급 비제이',
    'guild_anchor': '에이전트 보너스(일급)',
    'mouth_anchor_st': '월급 시작 시간',
    'mouth_anchor_et': '월급 종료 시간',
    'day_anchor_st': '일급 시작 시간',
    'day_anchor_et': '일급 종료 시간',
    'all_award_bcoin': '일급 보너스 총수익',
    'live_hour': '생방송 유효시간 보너스',
    'salary_day': '날짜',
    'day_in_come': '에이전트 당일수익(B코인)',
    'award_ration_flag_str': '보너스 비율',
    'payable_money': '에이전트 B코인 보너스',
    'host_bcoins': '비제이 수익 B코인',
    'total_official': '오피셜 B코인 총수',
    'actual_bcoins_awarded': '실제 B코인 보너스',
    "change_bound_account":"연동된 계정 바꾸기" ,
    "agent_id_form":"에이전트 ID :" ,
    "BuzzCast_verification_code":"BuzzCast 인증번호 :" ,
    "send_success":"보내기 성공" ,
    "account_changed_successfully":"연동된 계정이 성공적으로 교체되었습니다." ,
    "invite_guild_url":"버즈캐스트 에이전트로 초대 링크: {msg_ss}" ,
    "invite_guild_code":"내 초대 코드:{msg_ss}" ,
    "save":"저장" ,
    "compile":"편집" ,
    "agent_nvitation_eward":"에이전트 초대 보상" ,
    "agent_name":"에이전트 닉네임" ,
    "guild_id":"에이전시 코드" ,
    "guild_income_30days":"근 30일 에이전시 수입" ,
    "guild_invite_income_30days":"근 30일 초청받는 에이전시 수입" ,
    "agency_commission_ratio":"에이전트 커비션 비율" ,
    "invite_income_bcoins":"초대 비코인 보너스" ,
    "id_not_exist": "해당 ID 없음",
    'reward_distribution_status': '보상 분배 현황',
    'must_number': '입력은 순수 숫자 형식이어야 합니다.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ko.js